// removed by extract-text-webpack-plugin
module.exports = {"baseStyles":"BUvo1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Article/Article.scss
 ** module id = 469
 ** module chunks = 0
 **/